module.exports = __webpack_public_path__ + "static/media/square-root.bf9b15c1.svg";